import { type Nullable } from "@sunrise/utils";
import { atom } from "jotai";

/**
 * Whenever an error happens for which you want to notify the user, it should be stored in here.
 * Something else should listen to this and potentially pop up something for the user.
 */
export const errorAtom = atom<Nullable<Error>>(null);
